var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricetag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6046 1.69996C21.163 1.69871 21.6985 1.92162 22.0911 2.31871C22.4844 2.71092 22.7039 3.24452 22.7004 3.79996V9.56558C22.6994 9.94365 22.5491 10.306 22.2823 10.5739L10.7675 22.0864C9.94713 22.9052 8.61873 22.9052 7.7984 22.0864L2.31402 16.602C1.49559 15.7819 1.49559 14.454 2.31402 13.6339L13.8336 2.11668C14.1018 1.8504 14.4643 1.70066 14.8423 1.69996H20.6046ZM16.7004 6.19996C16.7004 7.02838 17.372 7.69996 18.2004 7.69996C18.5983 7.69996 18.9798 7.54192 19.2611 7.26062C19.5424 6.97931 19.7004 6.59778 19.7004 6.19996C19.7004 5.37153 19.0289 4.69996 18.2004 4.69996C17.372 4.69996 16.7004 5.37153 16.7004 6.19996Z",
    fill: "#3C00CF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricetag);
export default __webpack_public_path__ + "static/media/pricetag.164fd247b7b5b09f7e7f0407432fcadf.svg";
export { ForwardRef as ReactComponent };